export default __webpack_public_path__ + "static/2-9304cb79362b473276d50d5703b62e50.png";